var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNamespace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5652 61.5747C40.3067 62.8777 36.5714 62.7908 34.1392 61.401L20.6751 53.5831C18.3297 52.1933 18.156 50.0216 20.4145 48.7186C22.673 47.4157 26.4082 47.5025 28.8404 48.8924L42.3046 56.7102C44.7368 58.1001 44.8237 60.2717 42.5652 61.5747Z",
    fill: "url(#paint0_linear_1352_200795)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7242 6.87396C12.4499 8.71456 10.3768 13.0545 10.3768 19.2447C10.3768 30.4627 17.1967 43.5019 25.615 48.3553V7.72645C21.8369 5.54679 18.3882 5.38211 15.7242 6.87396Z",
    fill: "#DBDFE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3681 2.46617L23.31 2.49523C23.281 2.5146 23.2616 2.52429 23.2325 2.54367L15.7345 6.87392C18.3985 5.38206 21.8472 5.54675 25.6253 7.72641L33.2396 3.32834C29.4712 1.15837 26.0225 0.983999 23.3681 2.46617Z",
    fill: "#DBDFE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6152 7.72643V48.3553L33.2392 43.9572V3.32837L25.6152 7.72643Z",
    fill: "#DBDFE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7242 6.87396C12.4499 8.71456 10.3768 13.0545 10.3768 19.2447C10.3768 30.4627 17.1967 43.5019 25.615 48.3553V7.72645C21.8369 5.54679 18.3882 5.38211 15.7242 6.87396Z",
    fill: "#D7D7D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.358 2.46617L23.2998 2.49523C23.2708 2.5146 23.2514 2.52429 23.2223 2.54367L15.7243 6.87392C18.3883 5.38206 21.837 5.54675 25.6151 7.72641L33.2294 3.32834C29.461 1.15837 26.0123 0.983999 23.358 2.46617Z",
    fill: "url(#paint1_linear_1352_200795)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6152 7.72643V48.3553L33.2392 43.9572V3.32837L25.6152 7.72643Z",
    fill: "url(#paint2_linear_1352_200795)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7089 49.0914C33.0255 50.7092 29.4896 50.593 25.6243 48.3552V28.0408L35.7089 49.0914Z",
    fill: "#B9B9B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7095 49.0915L25.6152 28.0409L33.2392 23.6428L43.3237 44.6935L35.7095 49.0915Z",
    fill: "#B9B9B9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7089 49.0915C33.0255 50.7093 29.4896 50.5931 25.6244 48.3553V28.0409L35.7089 49.0915Z",
    fill: "#D7D7D7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6896 49.0043L25.5954 27.9536L33.2097 23.5555L43.3039 44.6062L35.6896 49.0043Z",
    fill: "url(#paint3_linear_1352_200795)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9973 42.1747C45.9973 48.239 44.0017 52.5305 40.8436 54.4292L30.7591 33.3785L45.9973 42.1747Z",
    fill: "#878787"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7709 33.3785L45.9994 42.1747L53.6234 37.7766L38.3851 28.9805L30.7709 33.3785Z",
    fill: "#B9B9B9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.997 42.1747C45.997 48.239 44.0014 52.5305 40.853 54.4292L48.4673 50.0311C51.6254 48.1324 53.621 43.8409 53.621 37.7766L46.0067 42.1747H45.997Z",
    fill: "#9F9F9F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8534 36.8371L25.6152 28.041V7.72656C34.0335 12.5896 40.8534 25.6191 40.8534 36.8371Z",
    fill: "#D7D7D7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2399 3.32837L25.6256 7.72643C28.3962 9.32485 31.0215 11.8145 33.2593 14.837C37.8123 20.9788 40.8542 29.3196 40.8542 36.837L48.4684 32.4389C48.4684 21.2209 41.6485 8.18174 33.2302 3.32837H33.2399Z",
    fill: "#D7D7D7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6152 7.72656V28.041L40.8534 36.8371L25.6152 28.041V7.72656Z",
    fill: "#84E0DD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2399 3.32837L25.6256 7.72643C28.3962 9.32485 31.0215 11.8145 33.2593 14.837C37.8123 20.9788 40.8542 29.3196 40.8542 36.837L48.4684 32.4389C48.4684 21.2209 41.6485 8.18174 33.2302 3.32837H33.2399Z",
    fill: "url(#paint4_linear_1352_200795)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6152 7.72656V28.041L40.8534 36.8371L25.6152 28.041V7.72656Z",
    fill: "#84E0DD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_200795",
    x1: 31.4708,
    y1: 64.3296,
    x2: 39.4893,
    y2: 50.5398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1352_200795",
    x1: 24.3461,
    y1: -4.55717,
    x2: 24.4526,
    y2: 3.62865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1352_200795",
    x1: 25.6152,
    y1: 25.8418,
    x2: 33.2392,
    y2: 25.8418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1352_200795",
    x1: 25.5954,
    y1: 36.2751,
    x2: 43.3039,
    y2: 36.2751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1352_200795",
    x1: 23.6397,
    y1: 20.7753,
    x2: 42.4138,
    y2: 19.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNamespace);
export default __webpack_public_path__ + "static/media/no_namespace.b654007212caf2dbb516a937c8e70d15.svg";
export { ForwardRef as ReactComponent };